import React from "react";
import { FaFacebook, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa6";
import { HiMail } from "react-icons/hi";
import carousel1 from "../images/carousel1.jpg";
import carousel2 from "../images/carousel2.jpg";
import carousel3 from "../images/carousel3.jpg";
import carousel4 from "../images/carousel4.jpg";
import carousel5 from "../images/carousel5.jpg";
import carousel6 from "../images/carousel6.jpg";

export const About = () => {
  return (
    <div>
      <div className=" text-white text-center my-6">
        <h1 className="text-4xl font-bold text-srs-pink">About Us</h1>
        <p className="text-lg sm:text-xl text-left my-7 mx-4 sm:mx-20">
          Salt River Shakedown fuse soul, indie, funk and rock to create an
          infectious sound that will be sure to tear the house down!{" "}
        </p>
        <p className="text-lg sm:text-xl text-left my-7 mx-4 sm:mx-20">
          {" "}
          Taking influence from the likes of{" "}
          <span className=" font-semibold">
            {" "}
            RHCP, Foo Fighters and Vulfpeck{" "}
          </span>
          , SRS underpin soulful guitar hooks and vocal melodies with punchy
          drums and driving bass lines to have you dancing the night away at
          their live gigs. This same infectious energy is captured live on their
          upcoming album, which is due to please your ears in early 2024.
        </p>
        
        <h2 className="text-2xl sm:text-4xl font-bold my-6 text-srs-pink">
          Our Socials
        </h2>

        <div className="flex justify-center gap-3 my-7 mt-8 sm:mt-0">
          <a
            href="https://www.facebook.com/saltrivershakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook className="text-white text-4xl hover:scale-110" />
          </a>
          <a
            href="https://www.instagram.com/saltrivershakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="text-white text-4xl hover:scale-110" />
          </a>
          <a
            href="https://www.youtube.com/@SaltRiverShakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube className="text-white text-4xl hover:scale-110" />
          </a>
          <a
            href="https://www.tiktok.com/@saltrivershakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok className="text-white text-4xl hover:scale-110" />
          </a>
        </div>
        <h4 className="text-2xl sm:text-4xl font-bold my-3 text-srs-pink">
          Contact And Bookings
        </h4>
        <div class="flex gap-1 sm:gap-3 items-center justify-center text-left">
          <div class="flex">
            <div class="flex-1 flex justify-center items-center">
              <HiMail className="text-white text-5xl sm:text-6xl" />
            </div>

            <div class="flex-1 items-center text-md font-semibold sm:text-xl m-1 sm:m-4">
              <p>saltrivershakedown@gmail.com</p>
              <p>pinknoisepromotions@gmail.com</p>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center text-lg sm:text-xl m-4">
          <p>
            Our Press Kit can be found{" "}
            <a
              className="underline font-semibold text-srs-pink"
              href="/SRS-EPK.pdf"
            >
              {" "}
              here{" "}
            </a>
          </p>
        </div>
        <div class="flex justify-center pt-7 ">
          <div class="columns-1 md:columns-2 max-w-4xl   pb-14">
            <img
              class="mb-4 m-auto border-srs-pink border-2 rounded-xl  "
              src={carousel1}
            />
            <img
              class="mb-4 border-srs-pink border-2 rounded-xl  "
              src={carousel2}
            />
            <img
              class="mb-4 border-srs-pink border-2 rounded-xl  "
              src={carousel3}
            />
            <img
              class="mb-4 border-srs-pink border-2 rounded-xl  "
              src={carousel4}
            />
            <img
              class="mb-4 m-auto border-srs-pink border-2 rounded-xl  "
              src={carousel5}
            />
            <img
              class="mb-4 border-srs-pink border-2 rounded-xl  "
              src={carousel6}
            />
           
          </div>
        </div>
      </div>

        <svg
          className=""
          viewBox="0 0 1440 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 28.8459L60 20.5216C120 12.1974 240 -4.4511 360 1.11574C480 6.47447 600 34.5688 720 37.1701C840 39.7715 960 17.9203 1080 12.1974C1200 6.47447 1320 17.9203 1380 23.2791L1440 28.8459V94H1380C1320 94 1200 94 1080 94C960 94 840 94 720 94C600 94 480 94 360 94C240 94 120 94 60 94H0V28.8459Z"
            fill="#FF87B0"
          />
          <path
            d="M0 41.5635L60 33.2393C120 24.915 240 8.26655 360 13.8334C480 19.1921 600 47.2865 720 49.8878C840 52.4891 960 30.638 1080 24.915C1200 19.1921 1320 30.638 1380 35.9967L1440 41.5635V98.5H1380C1320 98.5 1200 98.5 1080 98.5C960 98.5 840 98.5 720 98.5C600 98.5 480 98.5 360 98.5C240 98.5 120 98.5 60 98.5H0V41.5635Z"
            fill="#FFACA3"
          />
          <path
            d="M0 58.6805L60 50.3712C120 42.062 240 25.4434 360 31.0002C480 36.3493 600 64.3932 720 66.9898C840 69.5865 960 47.7746 1080 42.062C1200 36.3493 1320 47.7746 1380 53.1237L1440 58.6805V98.5H1380C1320 98.5 1200 98.5 1080 98.5C960 98.5 840 98.5 720 98.5C600 98.5 480 98.5 360 98.5C240 98.5 120 98.5 60 98.5H0V58.6805Z"
            fill="#8747D1"
          />
          <path
            d="M0 74.2885L60 65.9792C120 57.6699 240 41.0513 360 46.6081C480 51.9572 600 80.0011 720 82.5977C840 85.1944 960 63.3825 1080 57.6699C1200 51.9572 1320 63.3825 1380 68.7316L1440 74.2885V105.5H1380C1320 105.5 1200 105.5 1080 105.5C960 105.5 840 105.5 720 105.5C600 105.5 480 105.5 360 105.5C240 105.5 120 105.5 60 105.5H0V74.2885Z"
            fill="#472A84"
          />
        </svg>

    </div>
  );
};
